module.exports = __webpack_public_path__ + "img/feature_4.23936662.webp";